import { API_ENDPOINTS } from "./Constants";
import { apiFetch } from "./apiHelper";

export async function getRoles() {
    const res = await apiFetch(API_ENDPOINTS.LOOKUP_ROLES, { credentials: "include" });
    if (!res.ok) throw new Error("Greška pri dohvaćanju uloga");
    return res.json();
}

export async function getJobPositions() {
    const res = await apiFetch(API_ENDPOINTS.LOOKUP_JOB_POSITIONS, { credentials: "include" });
    if (!res.ok) throw new Error("Greška pri dohvaćanju radnih pozicija");
    return res.json();
}

export async function getDepartments() {
    const res = await apiFetch(API_ENDPOINTS.LOOKUP_DEPARTMENTS, { credentials: "include" });
    if (!res.ok) throw new Error("Greška pri dohvaćanju odjela");
    return res.json();
}

export async function getEmploymentStatuses() {
    const res = await apiFetch(API_ENDPOINTS.LOOKUP_EMPLOYMENT_STATUSES, { credentials: "include" });
    if (!res.ok) throw new Error("Greška pri dohvaćanju statusa zaposlenja");
    return res.json();
}

export async function addLookupItem(endpoint, name) {
    const res = await apiFetch(endpoint, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name }),
    });
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || "Greška pri dodavanju");
    }
    return res.json();
}

export async function updateLookupItem(endpoint, id, name) {
    const res = await apiFetch(`${endpoint}/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name }),
    });
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || "Greška pri ažuriranju");
    }
    return res.json();
}

export async function deleteLookupItem(endpoint, id) {
    const res = await apiFetch(`${endpoint}/${id}`, {
        method: "DELETE",
        credentials: "include",
    });
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || "Greška pri brisanju");
    }
}
